/* hs-eslint ignored failing-rules */

/* eslint-disable react/display-name */
'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useEffect } from 'react';
import { NotificationTypes } from 'AdsUI/lib/Constants';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import H5 from 'UIComponents/elements/headings/H5';
import { PermissionsMessage } from 'ads-account-connection/components/AccountPermissionsMessaging';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import PortalIdParser from 'PortalIdParser';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import UIBreakString from 'UIComponents/text/UIBreakString';
const settingsUrl = `/settings/${PortalIdParser.get()}/marketing/ads/leadSyncing`;

const SettingsLink = ({
  children
}) => /*#__PURE__*/_jsx(UILink, {
  external: true,
  href: settingsUrl,
  children: children
});

const ErrorFallbackText = ({
  errorType,
  errorSubtype
}) => {
  const subtypeLevelKey = `errors.message.subtypeLevel.${errorType}.${errorSubtype}_jsx`;
  const typeLevelKey = `errors.message.typeLevel.${errorType}_jsx`;

  if (isValidI18nKey(subtypeLevelKey)) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: subtypeLevelKey,
      elements: {
        SettingsLink
      }
    });
  }

  if (isValidI18nKey(typeLevelKey)) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: typeLevelKey,
      elements: {
        SettingsLink
      }
    });
  }

  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "errors.genericError"
  });
};

const ErrorTitle = ({
  actionType,
  text
}) => {
  if (I18n.lookup(`errors.titles.${actionType}`)) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: `errors.titles.${actionType}`
    });
  }

  if (text) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.sorry"
    });
  }

  return null;
};

const ErrorNotificationMessage = ({
  actionType,
  text,
  title,
  details,
  errorType,
  errorSubtype
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx(H5, {
    className: "m-bottom-2",
    children: title || /*#__PURE__*/_jsx(ErrorTitle, {
      actionType: actionType,
      text: text
    })
  }), /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("span", {
      children: text || /*#__PURE__*/_jsx(ErrorFallbackText, {
        errorType: errorType,
        errorSubtype: errorSubtype
      })
    }), details && /*#__PURE__*/_jsx(UIAccordionItem, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "errors.details"
      }),
      size: "extra-small",
      children: /*#__PURE__*/_jsx(UIBreakString, {
        children: /*#__PURE__*/_jsx("p", {
          children: details
        })
      })
    })]
  })]
});

const PermissionsErrorText = props => {
  useEffect(() => {
    usageTracker.track('errorDisplay', {
      type: 'permissions',
      form: 'banner'
    });
  }, []);
  return /*#__PURE__*/_jsx(PermissionsMessage, Object.assign({}, props, {
    onClick: () => {
      usageTracker.track('errorAction', {
        type: 'permissions',
        action: 'clicked kb link'
      });
    }
  }));
};

export const getPermissionsError = ({
  network,
  role,
  adAccount
}) => ({
  message: /*#__PURE__*/_jsx(ErrorNotificationMessage, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.permissions.headsUp"
    }),
    text: /*#__PURE__*/_jsx(PermissionsErrorText, {
      network: network,
      role: role,
      adAccount: adAccount
    })
  }),
  type: NotificationTypes.ERROR
}); // eslint-disable-next-line hubspot-dev/no-unnamed-components

export default ((_ref) => {
  let {
    actionType,
    text,
    title,
    details,
    errorType,
    errorSubtype
  } = _ref,
      extraParams = _objectWithoutPropertiesLoose(_ref, ["actionType", "text", "title", "details", "errorType", "errorSubtype"]);

  return Object.assign({
    message: /*#__PURE__*/_jsx(ErrorNotificationMessage, {
      actionType: actionType,
      errorType: errorType,
      errorSubtype: errorSubtype,
      text: text,
      details: details,
      title: title
    }),
    type: NotificationTypes.ERROR
  }, extraParams);
});